import simonGameImg from "../../../public/projects/simonGame.jpg";
import portfolioImg from '../../../public/logo.svg.png';
import moviesImg from '../../../public/projects/movies.jpg';
import expenseCalculator from '../../../public/projects/expense calculator.png';
import hotelBohemi from '../../../public/projects/Bohemi-logo.png';


const projectsData = [
    {
      image: simonGameImg,
      alt: "simon game",
      site: "https://dimitar33.github.io/Simon-Game/",
      code: "https://github.com/Dimitar33/Simon-Game",
    },
    {
      image: portfolioImg,
      alt: "my portfolio",
      site: "https://portfolio-2ca2f.web.app/",
      code: "https://github.com/Dimitar33/React-portfolio",
    },
    {
      image: moviesImg,
      alt: "movies api",
      site: "https://movies-api-4ce37.web.app",
      code: "https://github.com/Dimitar33/React-Projects/tree/master/Movies%20API",
    },
    {
      image: expenseCalculator,
      alt: "expense calculator",
      site: "https://expense-calculator-2caf3.web.app/",
      code: "https://github.com/Dimitar33/React-Projects/tree/master/First%20Project",
    },
    {
      image: hotelBohemi,
      alt: "hotel bohemi",
      site: "https://hotel-bohemi.web.app/",
      code: "https://github.com/Dimitar33/hotel-bohemi",
    },
  ];
  

  export default projectsData;